/** @jsx jsx */
import React, { useState, useEffect, useRef } from 'react';
import { jsx, Box, Heading, Grid, Button, Link, Text } from 'theme-ui';
import Blockies from 'react-blockies';
import { Skeleton } from 'antd';
/* const { Text } = Typography; */

export default function Address(props) {
	const [ ens, setEns ] = useState(0);
	useEffect(
		() => {
			if (props.value && props.ensProvider) {
				async function getEns() {
					let newEns;
					try {
						//console.log("getting ens",newEns)
						newEns = await props.ensProvider.lookupAddress(props.value);
						setEns(newEns);
					} catch (e) {}
				}
				getEns();
			}
		},
		[ props.value, props.ensProvider ]
	);

	if (!props.value) {
		return (
			<span>
				<Skeleton avatar paragraph={{ rows: 1 }} />
			</span>
		);
	}

	let displayAddress = props.value.substr(0, 6);

	if (ens) {
		displayAddress = ens;
	} else if (props.size === 'short') {
		displayAddress += '...' + props.value.substr(-4);
	} else if (props.size === 'long') {
		displayAddress = props.value;
	}

	let blockExplorer = 'https://etherscan.io/address/';
	if (props.blockExplorer) {
		blockExplorer = props.blockExplorer;
	}

	if (props.minimized) {
		return (
			<span style={{ verticalAlign: 'middle' }}>
				<a shref={blockExplorer + props.value}>
					<Blockies seed={props.value.toLowerCase()} size={8} scale={2} bgColor="#ffe" />
				</a>
			</span>
		);
	}

	let text;
	if (props.onChange) {
		text = (
			<Link
				sx={{ display: [ 'inline-block' ], mr: 'auto' }}
				href={blockExplorer + props.value}
				variant="links"
				target="_blank"
				className="tsf xas"
			>
				{displayAddress}
			</Link>
		);
	} else {
		text = (
			<Link
				sx={{ display: [ 'inline-block' ], mx: 'xs' }}
				href={blockExplorer + props.value}
				variant="links"
				target="_blank"
				className="tsf"
			>
				{displayAddress}
			</Link>
		);
	}

	return (
		<span>
			<span>
				<Blockies seed={props.value.toLowerCase()} size={4} scale={4} bgColor="#ffe" className="br100" />
			</span>
			<span>{text}</span>
		</span>
	);
}
